import axios from 'axios';

let prefix = "/equipment-tier"

const EquipmentTierApi = {
	listEquipmentTiers(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	getEquipmentTier(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
	createEquipmentTier(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateEquipmentTier(payload) {
		return axios.post(prefix + "/update", payload)
	},
	archiveEquipmentTier(payload) {
		return axios.delete(prefix + "/archive", { data: payload })
	},
}

export default EquipmentTierApi;
